module.exports = __webpack_public_path__ + "static/media/Intellect.694def77.svg";